import { forwardRef, useImperativeHandle, useLayoutEffect, useRef, useState } from "react";
import styles from "./ContextMenu.module.css"
import { Each } from "../common/Each";

// Componente che utilizza il context menu
const EDGE_PADDING = 8;

const ContextMenu = forwardRef(({ position, actions }, ref) => {

  const menuRef = useRef(null);
  const [adjustedPosition, setAdjustedPosition] = useState(position);

  useImperativeHandle(ref, () => menuRef.current);

  useLayoutEffect(() => {
    setAdjustedPosition(position);
  }, [position]);

  useLayoutEffect(() => {
    const menu = menuRef.current;
    if (!menu) {
      return;
    }

    const rect = menu.getBoundingClientRect();
    const { innerWidth, innerHeight, scrollX, scrollY } = window;

    let { x, y } = position;

    let clientX = x - scrollX;
    let clientY = y - scrollY;

    if (clientX + rect.width + EDGE_PADDING > innerWidth) {
      clientX = Math.max(EDGE_PADDING, innerWidth - rect.width - EDGE_PADDING);
      x = clientX + scrollX;
    }
    if (clientY + rect.height + EDGE_PADDING > innerHeight) {
      clientY = Math.max(EDGE_PADDING, innerHeight - rect.height - EDGE_PADDING);
      y = clientY + scrollY;
    }

    if (clientX < EDGE_PADDING) {
      clientX = EDGE_PADDING;
      x = clientX + scrollX;
    }
    if (clientY < EDGE_PADDING) {
      clientY = EDGE_PADDING;
      y = clientY + scrollY;
    }

    if (x !== adjustedPosition.x || y !== adjustedPosition.y) {
      setAdjustedPosition({ x, y });
    }
  }, [position, actions, adjustedPosition.x, adjustedPosition.y]);

  return (
    <div
      className={styles.container}
      ref={menuRef}
      style={{ top: adjustedPosition.y, left: adjustedPosition.x, zIndex: 9999 }}>
      <Each of={actions} render={(action) => {
        return (
          <div className={styles.action} style={{ color: action.color }} onClick={action.onClick}>
            {action.icon}
            <div className={styles.actionName}>{action.name}</div>
          </div>
        )
      }} />
    </div>
  )
});

export default ContextMenu;